function empty(element: HTMLElement): void {
    element.innerHTML = '';
}

// ----------------------------------------------------------------------------

export default empty;
